import { Link } from 'react-router-dom';

export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-smartphone-line',
      title: '下拉式阅读',
      desc: '专为手机优化的下拉式漫画阅读体验，流畅顺滑，无需翻页等待。',
    },
    {
      icon: 'ri-global-line',
      title: '海量韩漫资源',
      desc: '涵盖恋爱、动作、奇幻、悬疑等多个分类，超过1000部优质韩国漫画。',
    },
    {
      icon: 'ri-money-cny-circle-line',
      title: '完全免费',
      desc: '所有韩漫资源完全免费，无需付费订阅，随时随地畅享阅读乐趣。',
    },
    {
      icon: 'ri-speed-up-line',
      title: '极速加载',
      desc: '采用先进的图片压缩和CDN加速技术，确保漫画秒加载，阅读不卡顿。',
    },
    {
      icon: 'ri-bookmark-line',
      title: '阅读记录',
      desc: '自动保存阅读进度，下次继续阅读时无缝衔接，不错过任何一个精彩瞬间。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '正版授权',
      desc: '与韩国多家漫画平台合作，提供正版授权的韩漫内容，支持创作者。',
    },
  ];

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            为什么选择<span className="text-primary-600">yy漫画网</span>
          </h2>
          <p className="text-sm text-foreground-500 mt-2">致力于为读者提供最好的韩漫阅读体验</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500 group-hover:bg-primary-100 transition-colors mb-4">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}